import { getThemeComponent } from '@/utils/themeImports';
import { specificThemeRender } from '@/utils/specificThemeRender';
import useIsComponentMounted from '@/utils/useIsComponentMounted';
import { PATH, getRoute } from '@/utils/routes';
import getCustomCtaText from '@/utils/getCustomCtaText';
import { useRouter } from 'next/router';
import { useSSRSelector } from '@/redux/ssrStore';
import { IS_MOBILE } from '@/utils/checkClientDeviceType';

const MobileHeader = ({ storeData }) => {
  const router = useRouter();

  return (
    <header className="mobile-header">
      <article className="header-top">
        <img
          className="back-icon"
          loading="lazy"
          src="https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp"
          alt="back"
          onClick={() => {
            router.push(getRoute(PATH.PRODUCT, storeData.store_info.domain));
          }}
        />
        <span className="header-title">{getCustomCtaText('my_orders_cta')}</span>
      </article>
    </header>
  );
};

const DesktopHeader = ({ storeData }) => {
  const isComponentMounted = useIsComponentMounted();

  if (!isComponentMounted) {
    return null;
  }

  return specificThemeRender(storeData)?.components.Header.map((layout) => {
    return getThemeComponent(layout.sub_type, layout.name, layout);
  });
};

export const Header = () => {
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  if (IS_MOBILE) {
    return <MobileHeader storeData={storeData} />;
  }

  return <DesktopHeader storeData={storeData} />;
};
